import { useCallback, useEffect, useMemo, useState } from "react";
import AssetFleetProcessing from "./AssetFleetProcessing";
import { useDispatch, useSelector } from "react-redux";
import { setDispositionData, setTransferData } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";
import { useNavigate, useParams } from "react-router-dom";
import { getAssignToDropdown } from "redux/PurchaseOrder/action";
import { getDispositionChoice } from "Store/OrderManagement/DispositionChoice/DispositionChoiceAction";
import { getReasonCode } from "Store/OrderManagement/ReasonCode/ReasonCodeAction";
import { getAssignmentTransferTypes } from "Store/OrderManagement/AssignmentTransferTypes/AssignmentTransferTypesAction";
import { getCostCenterBySearchString } from "Store/Organization/CostCenters/CostCentersAction";
import { getStates } from "Store/Organization/States/StatesAction";
import userProfileSelectors from "../../../../redux/UserProfile/selectors"
import { getSaveReceivingBranch, setSaveReceivingBranch } from "Store/FleetManagement/FleetTransferReceivingBranch/FleetTransferReceivingBranchAction";
import ConfirmationBee from "../../../assets/images/ConfirmationBee.svg"
import succesBee from '../../../assets/images/SuccessBee.svg'
import CommentBee from '../../../assets/images/PenndingApproval/Comment Bee.png'
import permissions, { isAuthorized } from "client/utils/Permissions";
import { CONSTANTS } from "client/utils/constants";
import { getFleetCommentsHistory, getSaveFleetComments, setFleetCommentsHistory, setSaveFleetComments } from "Store/FleetManagement/FleetAssetCommentsSave/FleetAssetCommentsSaveActions";
import { setAdminTaskGridValues, setInitialTaskDetail, setLinkedAttachments, setOpenAccordionList, setRecevingCostCenterOption } from "Store/Component/FleetManagement/FleetManagementAction";
import { GetStatusIcon } from "client/utils/IconsUtil";
import { commonDispValidation, formatLableValue, getOnlyNumbersWithSign, popupInitialData } from "utils";
import Validation from "../Asset/TransferOrder/CreateNewRequisition/Disposition/dispositionValidation";
import SubChoiceValidation from "../Asset/TransferOrder/CreateNewRequisition/Disposition/DispositionSubChoices/dispositionSubChoicesValidation";
import { getSaveFleetDispositionLocation, setSaveFleetDispositionLocation } from "Store/FleetManagement/FleetDispositionLocationsave/FleetDispositionLocationsaveAction";
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import { getFleetAfeChangeLog, getFleetAssetChangeLog } from "Store/FleetManagement/FleetAssetChangeLog/FleetAssetChangeLogAction";
import _ from "lodash";
import { saveDispositionPayment, setDispositionPaymentData, setDispositionPaymentSaveStatus } from "Store/FleetManagement/FleetDispositionPaymentSave/FleetDispositionPaymentSaveAction";
import { setSavedStatus } from "Store/FleetManagement/FleetAdminTask/AdminTaskAction";
import { getAfeFleetItemDetails, getAfeFleetTaskDetails, getAfeOrderHeaderDetail, getAssetFleetItemDetails, getAssetFleetTaskDetails, getAssetOrderHeaderDetail, saveAssetAssignedToForAllItem, setAfeFleetHeaderDetail, setAfeFleetItemDetails, setAfeFleetTaskDetails, setAssetFleetHeaderDetail, setAssetFleetItemDetails, setAssetFleetTaskDetails, setAssetOpenAccordionList, setAssetOrderHeaderDetail } from "Store/FleetManagement/AssetFleetProcessing/AssetFleetProcessingAction";
import { setAssetFleetItemCancel } from "Store/FleetManagement/FleetItemCancel/FleetItemCancelAction";
import { operations } from "redux/Navigation";
import moment from "moment";
import { getAssetFleetItemReturnToRequestor, setAssetFleetItemReturnToRequestor } from "Store/FleetManagement/FleetItemReturnToRequestor/FleetItemReturnToRequestorAction";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";

const AssetFleetProcessingContainer = (props: any) => {
  const { setSelectedKey, tabSwitchClicked, setTabSwitchClicked, tab} = props;  

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const navDispatch = operations.dispatchNav(dispatch);
    let { id, pagename, requesttype } = useParams();

    const {
        assignmentList,        
        transferData,
        userDetails,
        savedStatus,
        assetFleetItemCancel,
        receivingBranchValues,
        fleetAssetComments,
        fleetAssetCommentsHistory,
        receivingCostCenterOption,    
        SavedAdminTaskValue,
        assetDisposition,
        fleetDispositionLocationValue,
        dispositionPaymentData,
        dispositionPaymentDataSaveStatus,
        assetOrderHeaderDetail,
        assetFleetItemDetail,
        assetFleetTaskDetail,
        adminTaskGridValues,
        initialTaskDetail,
        assetFleetItemReturn,
        costCenterBySearchDropDownList,
        assignTo,
        assetAssignedToForAllItem,
        assetOpenAccordionList,
        afeFleetHeaderDetail,
        afeFleetItemDetail,
        afeFleetTaskDetail
      }: any = useSelector((state?: any) => ({
        assignmentList: state.AssignmentTransferTypesReducer.assignmentTransferTypesList,        
        transferData: state.FleetProcessingReducer.transferData,
        userDetails: userProfileSelectors.getUserDetails(state),
        savedStatus: state.adminTaskReducer.savedStatus,
        assetFleetItemCancel: state.FleetItemCancelReducer.assetFleetItemCancel,
        receivingBranchValues: state.ReceivingBranchReducer.receivingBranchValues,
        fleetAssetComments: state.FleetAssetCommentsReducer.fleetAssetComments,
        fleetAssetCommentsHistory: state.FleetAssetCommentsReducer.fleetAssetCommentsHistory,
        receivingCostCenterOption: state.fleetAdminTaskReducer.receivingCostCenterOption,        
        SavedAdminTaskValue: state.adminTaskReducer.SavedAdminTaskValue,
        assetDisposition: state.FleetProcessingReducer.dispositionData,
        fleetDispositionLocationValue: state.FleetDispositionLocationReducer.fleetDispositionLocationValue,
        dispositionPaymentData: state.FleetDispositionPaymentReducer.dispositionPaymentData,
        dispositionPaymentDataSaveStatus: state.FleetDispositionPaymentReducer.status,
        assetOrderHeaderDetail: state.AssetFleetProcessingReducer.assetOrderHeaderDetail,
        assetFleetItemDetail: state.AssetFleetProcessingReducer.assetFleetItemDetail,
        assetFleetTaskDetail: state.AssetFleetProcessingReducer.assetFleetTaskDetail,
        adminTaskGridValues: state.fleetAdminTaskReducer.adminTaskGridValues,
        initialTaskDetail: state.fleetAdminTaskReducer.initialTaskDetail,
        assetFleetItemReturn: state.FleetItemReturnReducer.assetFleetItemReturn,
        costCenterBySearchDropDownList: state.CostCentersReducer.costCenterBySearchDropDownList,
        assignTo: state.PurchaseOrder.assignTo,
        assetAssignedToForAllItem: state.AssetFleetProcessingReducer?.assetAssignedToForAllItem,
        assetOpenAccordionList: state.AssetFleetProcessingReducer.assetOpenAccordionList,
        afeFleetHeaderDetail: state.AssetFleetProcessingReducer.afeFleetHeaderDetail,
        afeFleetItemDetail: state.AssetFleetProcessingReducer.afeFleetItemDetail,
        afeFleetTaskDetail: state.AssetFleetProcessingReducer.afeFleetTaskDetail
      }));
      const [assetDeterminationValue, setAssetDeterminationValue] = useState<any>(null);
      const [newAssetValue, setNewAssetValue] = useState<any>(null);
      const [assignmentTransferTypesList, setAssignmentTransferTypesList] = useState<any>([]);
      const [assignedToError, setAssignedToError] = useState<any>([]);
      const [newAssetError, setNewAssetError] = useState<any>([]);
      const [attachmentChangeFleetId, setAttachmentChangeFleetId] = useState<any>();
      const [comments, setComments] = useState<any>("");
      const [commentsError, setCommentsError] = useState<any>("")
      const [activeStepperArr, setActiveStepperArr] = useState<any>([]);
      const [receivingBranchChangeValue, setReceivingBranchChangeValue] = useState<any>([]);
      const [fleetItemIdTemp, setFleetItemIdTemp] = useState<any>([]);
      const [activeStepper, setActiveStepper] = useState<number>(1);
      const [commentHistoryList, setCommentHistoryList] = useState<any>([]);
      const [isChangeOccuredFlag, setIsChnagedOccuredFlag] = useState<any>(false)
      const [validatePaymentInfo, setValidatePaymentInfo] = useState<boolean>(false)
      const [changesOccuredOnPayment, setChangesOccuredOnPayment] = useState<boolean>(false)
      const [cancelComments, setCancelComments] = useState<any>('');
      const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
      const [returnPopupcontent, setReturnPopupcontent] = useState<any>(popupInitialData);
      const [costCentersBySearchList, setCostCentersBySearchList] = useState([]);
      const [isAssignedToChecked, setIsAssignedToChecked] = useState<boolean>(false);
      const [assignedToForAllValue, setAssignedToForAllValue] = useState<any>();

  useEffect(() => {
    dispatch(getAssignToDropdown())
    dispatch(getDispositionChoice());
    dispatch(getReasonCode());
    dispatch(getAssignmentTransferTypes());
    dispatch(getStates());
    dispatch(setFleetCommentsHistory([]));
    dispatch(setSavedStatus([]))
    setCostCentersBySearchList([])
  }, [])

  const onChangeCommentsAccordian = () => {
    dispatch(getFleetCommentsHistory(id))
  }

  useEffect(()=>{
    setIsAssignedToChecked(assetOrderHeaderDetail?.isLockedBy)
    setAssignedToForAllValue(assetOrderHeaderDetail?.lockedBy)
  },[assetOrderHeaderDetail?.lockedBy, assetOrderHeaderDetail?.isLockedBy])

  useEffect(()=>{
    if(assetAssignedToForAllItem?.response && assetAssignedToForAllItem?.payload?.fleetItemIds?.length){
      const fleetIds = assetAssignedToForAllItem?.payload?.fleetItemIds
      const filteredArray = fleetIds?.filter((value:any) => assetOpenAccordionList?.includes(value));
      filteredArray?.map((item:any)=>{
          dispatch(getFleetAssetChangeLog(item))
      })
      let transferDataTemp = transferData?.length ? JSON.parse(JSON.stringify(transferData)) : [];
      transferDataTemp?.map((request: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any) => {
          if(filteredArray?.includes(itemLevel?.fleetRequestDetailId)){
            itemLevel.assignedTo = assetAssignedToForAllItem?.payload?.assignedTo
          }
        })
      })   
      dispatch(setTransferData(transferDataTemp))
    }
  },[assetAssignedToForAllItem])

  useEffect(() => {
    if (costCenterBySearchDropDownList?.length) {
      const costcenterDropdownListTemp = costCenterBySearchDropDownList?.map((item: any) => ({ ...item, label: item?.text, key: item?.value }));
      setCostCentersBySearchList(costcenterDropdownListTemp);
    }
  }, [costCenterBySearchDropDownList])

  useEffect(() => {
    if (assetFleetTaskDetail?.response) {
      let transferDataTemp = transferData?.length ? JSON.parse(JSON.stringify(transferData)) : [];
      let adminTaskGridValuesTemp: any = []
      transferDataTemp?.map((request: any, index: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any) => {
          if (itemLevel?.fleetRequestDetailId === assetFleetTaskDetail?.fleetRequestDetailId) {
            adminTaskGridValuesTemp = adminTaskGridValues?.length ? adminTaskGridValues?.filter((item?: any) => item?.itemId != itemLevel?.assetNo) : []
            itemLevel.fleetRequestTransDispoReactTaskListTrackings = assetFleetTaskDetail?.response
            let listTemp: any = {}
                listTemp.itemId = itemLevel?.assetNo
                listTemp.taskList = assetFleetTaskDetail?.response
                listTemp.itemStatus = itemLevel?.itemStatus
                listTemp.fleetStatus = itemLevel?.fleetStatus
                listTemp.orderStatus = itemLevel?.orderStatus
                adminTaskGridValuesTemp?.push(listTemp)
                dispatch(setAdminTaskGridValues(adminTaskGridValuesTemp))

                let initialTaskDetailTemp = initialTaskDetail?.length ? initialTaskDetail?.filter((initialItem?: any) => initialItem?.itemId != itemLevel?.assetNo) : []
                initialTaskDetailTemp?.push(listTemp)
                dispatch(setInitialTaskDetail(initialTaskDetailTemp))

                let savedStatusTemp = savedStatus?.filter((statusItem?: any) => statusItem?.fleetItemId != assetFleetTaskDetail?.fleetRequestDetailId)
                let saveObj: any = {}
                saveObj.fleetItemId = assetFleetTaskDetail?.fleetRequestDetailId
                saveObj.itemStatus = itemLevel?.itemStatus
                saveObj.fleetStatus = itemLevel?.fleetStatus
                saveObj.orderStatus = itemLevel?.orderStatus
                saveObj.taskList = assetFleetTaskDetail?.response
                savedStatusTemp?.push(saveObj)
                dispatch(setSavedStatus(savedStatusTemp))

          }
        })

      })             
      dispatch(setTransferData(transferDataTemp))
    }
  }, [assetFleetTaskDetail])

  useEffect(() => {
    if (afeFleetTaskDetail?.response) {
      let transferDataTemp = transferData?.length ? JSON.parse(JSON.stringify(transferData)) : [];
      let adminTaskGridValuesTemp: any = []
      transferDataTemp?.map((request: any, index: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any) => {
          if (itemLevel?.fleetRequestDetailId === afeFleetTaskDetail?.fleetRequestDetailId) {
            adminTaskGridValuesTemp = adminTaskGridValues?.length ? adminTaskGridValues?.filter((item?: any) => item?.itemId != itemLevel?.assetNo) : []
            itemLevel.fleetRequestTransDispoReactTaskListTrackings = afeFleetTaskDetail?.response
            let listTemp: any = {}
                listTemp.itemId = itemLevel?.assetNo
                listTemp.taskList = afeFleetTaskDetail?.response
                listTemp.itemStatus = itemLevel?.itemStatus
                listTemp.fleetStatus = itemLevel?.fleetStatus
                listTemp.orderStatus = itemLevel?.orderStatus
                adminTaskGridValuesTemp?.push(listTemp)
                dispatch(setAdminTaskGridValues(adminTaskGridValuesTemp))

                let initialTaskDetailTemp = initialTaskDetail?.length ? initialTaskDetail?.filter((initialItem?: any) => initialItem?.itemId != itemLevel?.assetNo) : []
                initialTaskDetailTemp?.push(listTemp)
                dispatch(setInitialTaskDetail(initialTaskDetailTemp))

                let savedStatusTemp = savedStatus?.filter((statusItem?: any) => statusItem?.fleetItemId != assetFleetTaskDetail?.fleetRequestDetailId)
                let saveObj: any = {}
                saveObj.fleetItemId = afeFleetTaskDetail?.fleetRequestDetailId
                saveObj.itemStatus = itemLevel?.itemStatus
                saveObj.fleetStatus = itemLevel?.fleetStatus
                saveObj.orderStatus = itemLevel?.orderStatus
                saveObj.taskList = afeFleetTaskDetail?.response
                savedStatusTemp?.push(saveObj)
                dispatch(setSavedStatus(savedStatusTemp))

          }
        })

      })             
      dispatch(setTransferData(transferDataTemp))
    }
  }, [afeFleetTaskDetail])

  useEffect(() => {
    if (assetFleetItemDetail?.response) {
      dispatch(getAssetFleetTaskDetails(assetFleetItemDetail?.fleetRequestDetailId))
      let transferDataTemp = transferData?.length ? JSON.parse(JSON.stringify(transferData)) : [];
      transferDataTemp?.map((request: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any, index: any) => {
          if (itemLevel?.fleetRequestDetailId === assetFleetItemDetail?.fleetRequestDetailId) {
            request?.fleetAssetDetails?.splice(index, 1, assetFleetItemDetail?.response)
          }
        })

      })
      dispatch(setTransferData(transferDataTemp))
      let alreadyLinkedattacment: any = []
      transferDataTemp?.map((request: any, index: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any) => {
          let objAttachments: any = {}
          objAttachments.fleetItemId = itemLevel?.fleetRequestDetailId
          objAttachments.attachments = itemLevel?.attachments
          alreadyLinkedattacment.push(objAttachments)

        })
      })
      dispatch(setLinkedAttachments(alreadyLinkedattacment))
    }
  }, [assetFleetItemDetail])

  useEffect(() => {
    if (afeFleetItemDetail?.response) {
      dispatch(getAfeFleetTaskDetails(afeFleetItemDetail?.fleetRequestDetailId))
      let transferDataTemp = transferData?.length ? JSON.parse(JSON.stringify(transferData)) : [];
      transferDataTemp?.map((request: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any, index: any) => {
          if (itemLevel?.fleetRequestDetailId === afeFleetItemDetail?.fleetRequestDetailId) {
            request?.fleetAssetDetails?.splice(index, 1, afeFleetItemDetail?.response)
          }
        })

      })
      dispatch(setTransferData(transferDataTemp))
      let alreadyLinkedattacment: any = []
      transferDataTemp?.map((request: any, index: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any) => {
          let objAttachments: any = {}
          objAttachments.fleetItemId = itemLevel?.fleetRequestDetailId
          objAttachments.attachments = itemLevel?.attachments
          alreadyLinkedattacment.push(objAttachments)

        })
      })
      dispatch(setLinkedAttachments(alreadyLinkedattacment))
    }
  }, [afeFleetItemDetail])

  useEffect(() => {
    if(transferData?.length){
    let stepperArr: any = []
    let paymentData: any = []
    transferData?.map((itemVal?: any, itemIndex?: any) => {
      itemVal?.fleetAssetDetails?.map((requestVal?: any, requestIndex?: any) => {
        stepperArr.push({
          fleetRequestDetailId: requestVal.fleetRequestDetailId,
          activeStepperVal: requestVal?.isLeased ? 2 : 1
        })
        paymentData.push({
          fleetRequestTransDispoReactivationDetailId: parseInt(requestVal?.fleetRequestDetailId),
          dispositionPayment: {
            isCheck: requestVal?.dispositionPayment?.isCheck == undefined ? false : requestVal?.dispositionPayment?.isCheck,
            checkOrWireNo: requestVal?.dispositionPayment?.checkOrWireNo || '',
            buyerName: requestVal?.dispositionPayment?.buyerName || '',
            totalCheckOrWireAmount: requestVal?.dispositionPayment?.totalCheckOrWireAmount || '',
            allocatedAmount: requestVal?.dispositionPayment?.allocatedAmount || '',
          },
          dispositionTitle: {
            requestedTitle: requestVal?.dispositionTitle?.requestedTitle || '',
            receivedTitle: requestVal?.dispositionTitle?.receivedTitle || '',
            shippedTitle: requestVal?.dispositionTitle?.shippedTitle || '',
            trackingNo: requestVal?.dispositionTitle?.trackingNo || '',
          },
          savedBy: userDetails?.emailId,
          itemStatus: requestVal?.itemStatus
        })
      })
      setActiveStepperArr(stepperArr);
      dispatch(setDispositionPaymentData(paymentData))
    })
    if(transferData?.isLeased != null){
      dispatch(getDispositionChoice(transferData?.isLeased));
    }  
  }
  }, [transferData])

  useEffect(() => {
    if (id != undefined && isAuthorized(permissions.ViewPurchaseOrders)) {
      dispatch(setAssetOrderHeaderDetail({}))
      requesttype === CONSTANTS.AFEREQUEST ? dispatch(getAfeOrderHeaderDetail(id)) : dispatch(getAssetOrderHeaderDetail(id))  
      if (requesttype === CONSTANTS.AFEREQUEST) {
        dispatch(setAfeFleetHeaderDetail([]))  
      } else {
        dispatch(setAssetFleetHeaderDetail({}))  
      }
      
      dispatch(setAssetFleetItemDetails({}))
      dispatch(setAssetFleetTaskDetails([]))
      dispatch(setDispositionData({}))
      dispatch(setAdminTaskGridValues([]))
      dispatch(setAfeFleetItemDetails({}))
      dispatch(setAfeFleetTaskDetails({}))
      dispatch(setSaveFleetDispositionLocation({}))
      dispatch(setInitialTaskDetail([]))
    }
  }, [id, userDetails?.permissions])

  useEffect(() => {
    const tempList = assignmentList?.map((item: any) =>
      ({ label: item.text, key: item.value, ...item })
    );
    setAssignmentTransferTypesList(tempList)
  }, [assignmentList])

  const getPreExpandedItem = (request?: any) => {
      let preExpandedItem: any[] = [];
      request?.fleetAssetDetails?.forEach((item: any, index: any) => {
        preExpandedItem.push("FleetAsset_Accordion_" + index)
      })
      return preExpandedItem
  }

  const onChangeReceivingCostCenter = (selectedItem: any, selectedIndex: any) => {
    setCostCentersBySearchList([]);
    if (selectedItem?.label == assetOrderHeaderDetail?.costCenter) {
      const assetOrderDetailsTemp = transferData?.map((request: any, index: any) => {
        if (index === selectedIndex) {
            request.transferReceivingBranch.receivingCostCenterError = "Please select another cost center"
            request.transferReceivingBranch.receivingCostCenterCode = selectedItem.key
            request.transferReceivingBranch.receivingCostCenter = selectedItem.label
          return request
        } else {
          return request
        }
      })
      dispatch(setTransferData(assetOrderDetailsTemp))
      }else{
        let fleetItemId : any = [];
        transferData?.map((request: any, index: any) => {
            if(index === selectedIndex){
            request?.fleetAssetDetails?.map((itemLevel: any) => {
                 fleetItemId?.push(parseInt(itemLevel?.fleetRequestDetailId))
            })
            setFleetItemIdTemp(fleetItemId)
            }            
        })
        const assetOrderDetailsTemp = transferData?.map((request: any, index:any) => {
            if(index === selectedIndex){
                request.branchName= selectedItem.text
                request.branchNumber= selectedItem.key
                request.costCenter= selectedItem.text
                request.transferReceivingBranch.receivingCostCenterCode= selectedItem.key
                request.transferReceivingBranch.receivingCostCenter = selectedItem.label
                request.transferReceivingBranch.receivingCostCenterError = ""
                setReceivingBranchChangeValue(fleetItemId)
                dispatch(getSaveReceivingBranch({
                    "receivingBranchId": parseInt(selectedItem.key),
                    "fleetDetailIds": fleetItemId,
                    "savedBy": userDetails?.emailId
                }))
                return request
            }else{
                return request
            }    
        })
        dispatch(setTransferData(assetOrderDetailsTemp))
      }
    }

  const getAssignmentTransferTypeValue = (transferType: any) => {
    let selectedValue = {};
    assignmentList?.map((item: any) => {
      if (item.value == transferType) {
        selectedValue = { label: item.text, key: item.value, ...item };
      }
    });
    return selectedValue;
  }

  const hideConfirmationDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const dismissAlert = () => dispatch(setSaveReceivingBranch(null))
  useEffect(() => {
    if (receivingBranchValues != null) {
      setTimeout(() => {
        fleetItemIdTemp?.map((id?: any) => {
           dispatch(getFleetAssetChangeLog(id))
        })
        dispatch(setSaveReceivingBranch(null))
        setReceivingBranchChangeValue([])
        setFleetItemIdTemp([])
      }, 5000);
    }
    },[receivingBranchValues])
   
  const isShowAlert = (request?: any) => {
    let fleetItemId : any = [];
    request?.fleetAssetDetails?.forEach((item: any) => {
      fleetItemId?.push(item?.fleetRequestDetailId)
    })
    if(fleetItemId.sort().toString() == receivingBranchChangeValue.sort().toString()){
         return true
    }else{
      return false
    }
  }

  useEffect(() => {
    if (assetFleetItemCancel?.hasOwnProperty('response') && assetFleetItemCancel?.response) {
      let transferDataTemp = transferData ? JSON?.parse(JSON.stringify(transferData)) : []
      let adminTaskGridValuesTemp: any = []
      transferDataTemp?.map((request: any) => {
        request?.fleetAssetDetails?.map((itemVal: any) => {
          if (itemVal?.fleetRequestDetailId == assetFleetItemCancel?.fleetItemId?.fleetDetailId) {
            itemVal.fleetStatus = assetFleetItemCancel?.response?.fleetStatus
            itemVal.itemStatus = assetFleetItemCancel?.response?.itemStatus
            itemVal.orderStatus = assetFleetItemCancel?.response?.orderStatus
            itemVal.cancelComments = cancelComments
            adminTaskGridValuesTemp = adminTaskGridValues?.length ? adminTaskGridValues?.filter((item?: any) => item?.itemId != itemVal?.assetNo) : []
            let listTemp: any = {}
                listTemp.itemId = itemVal?.assetNo
                listTemp.taskList = itemVal?.fleetRequestTransDispoReactTaskListTrackings
                listTemp.itemStatus = itemVal?.itemStatus
                listTemp.fleetStatus = itemVal?.fleetStatus
                adminTaskGridValuesTemp?.push(listTemp)
                dispatch(setAdminTaskGridValues(adminTaskGridValuesTemp))

                let initialTaskDetailTemp = initialTaskDetail?.length ? initialTaskDetail?.filter((initialItem?: any) => initialItem?.itemId != itemVal?.assetNo) : []
                initialTaskDetailTemp?.push(listTemp)
                dispatch(setInitialTaskDetail(initialTaskDetailTemp))

                ///To Change (Item and Fleet status) after save
                let savedStatusTemp = savedStatus?.filter((statusItem?: any) => statusItem?.fleetItemId != assetFleetItemCancel?.fleetItemId?.fleetDetailId)
                let saveObj: any = {}
                saveObj.fleetItemId = assetFleetItemCancel?.response?.fleetDetailId
                saveObj.itemStatus = assetFleetItemCancel?.response?.itemStatus
                saveObj.fleetStatus = assetFleetItemCancel?.response?.fleetStatus
                saveObj.orderStatus = assetFleetItemCancel?.response?.orderStatus
                saveObj.taskList = itemVal?.fleetRequestTransDispoReactTaskListTrackings
                savedStatusTemp?.push(saveObj)
                dispatch(setSavedStatus(savedStatusTemp))
                setCancelComments('')
          }
        })
      })
      dispatch(setTransferData(transferDataTemp))
      const assetOrderHeaderDetailTemp = assetOrderHeaderDetail ? JSON.parse(JSON.stringify(assetOrderHeaderDetail)) : {}
      if (assetOrderHeaderDetailTemp) {
        assetOrderHeaderDetailTemp.orderStatus = assetFleetItemCancel?.response?.orderStatus
        assetOrderHeaderDetailTemp.fleetRequestDetail = transferDataTemp
      }
      dispatch(setAssetOrderHeaderDetail(assetOrderHeaderDetailTemp))
      dispatch(setAssetFleetItemCancel(null))
    } else if (assetFleetItemCancel?.hasOwnProperty('response') && !assetFleetItemCancel?.response) {
      let decriptionTxt = (
        <div>
          <p>Error occured while cancelling the item.</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          setTabSwitchClicked(false);
        },
      });
    }
  }, [assetFleetItemCancel])

  const commonReturnsuccessPopup = (isLastItemReturned?: any) => {
    let decriptionTxt = (
      <div>
        <p>{isLastItemReturned ? 'Order' : 'Item'} has been returned to requestor successfully.</p>
      </div>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: succesBee,
      title: CONSTANTS.ORDER_STATUS.RETURNED,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "OK",
      popupOutlinebtnOnclick: () => {
        if (isLastItemReturned) {
          dispatch(setAssetFleetItemReturnToRequestor(null))
          if (pagename === CONSTANTS.PAGE_NAME.REQUISITION) {
            navDispatch('Customer My Orders')
          } else if (pagename === CONSTANTS.PAGE_NAME.ASSET) {
            navDispatch('Asset')
          } else {
            navDispatch('Home')
          }
          navigate('/ordermanagement');
        } else {
          let transferDataTemp = transferData ? JSON?.parse(JSON.stringify(transferData)) : []
          const fleetIds = new Set(assetFleetItemReturn?.response?.items);
          transferDataTemp?.map((request: any) => {
            if (request?.fleetAssetDetails) {
              request.fleetAssetDetails = request?.fleetAssetDetails?.filter((itemVal: any) => {
                return fleetIds.has(itemVal?.fleetRequestDetailId);
              });
            }
            return request;
          })
          dispatch(setTransferData(transferDataTemp))
          const assetOrderHeaderDetailTemp = assetOrderHeaderDetail ? JSON.parse(JSON.stringify(assetOrderHeaderDetail)) : {}
          if (assetOrderHeaderDetailTemp) {
            assetOrderHeaderDetailTemp.orderStatus = assetFleetItemReturn?.response?.orderStatus
            assetOrderHeaderDetailTemp.fleetRequestDetail = transferDataTemp
            assetOrderHeaderDetailTemp.quantity = assetFleetItemReturn?.response?.quantity
            assetOrderHeaderDetailTemp.bosAttachment = assetFleetItemReturn?.response?.bosAttachment
          }
          dispatch(setAssetOrderHeaderDetail(assetOrderHeaderDetailTemp))
          dispatch(setAssetFleetItemReturnToRequestor(null))
        }
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      },
      hideDialog: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      },
      isSingleConfirmationBtn: true,
    });
  }

  useEffect(() => {
    if (assetFleetItemReturn != null && assetFleetItemReturn?.isReturned && assetFleetItemReturn?.hasOwnProperty('response') && assetFleetItemReturn?.response?.quantity >= 1) {
      commonReturnsuccessPopup(false)
    } else if(assetFleetItemReturn?.response?.quantity == 0 && assetFleetItemReturn != null){   
      commonReturnsuccessPopup(true)
    } else if (assetFleetItemReturn != null && !assetFleetItemReturn?.isReturned) {
      dispatch(setAssetFleetItemReturnToRequestor(null))
      let decriptionTxt = (
        <div>
          <p>Error occured while Returning the order.</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          setTabSwitchClicked(false);
        },
      });
    }
  }, [assetFleetItemReturn])


  const errors = [
    "assetDispositionSubChoiceError",
    "assetDispositionNameError",
    "assetDispositionAddress1Error",
    "assetDispositionAddress2Error",
    "assetDispositionCityError",
    "assetDispositionStateError",
    "assetDispositionZipError",
    "assetDispositionPhoneError",
    "assetDispositionSalePriceError",
    "assetDispositionTotalPriceError",
    "assetLocationNameError",
    "assetLocationAddress1Error",
    "assetLocationAddress2Error",
    "assetLocationCityError",
    "assetLocationStateError",
    "assetLocationZipError",
    "assetLocationPhoneError",
    "assetLotionSalePriceError",
    "assetLocationContactNameError",
    "assetLocationEmailError"
  ]

  const validate = () => {
    let validToShowMyCart = true;
    let dispositionTemp = JSON.parse(JSON.stringify(assetDisposition))
    dispositionTemp = commonDispValidation(assetDisposition, Validation, SubChoiceValidation, dispositionTemp, false)
    if (assetDisposition?.assetDispositionChoice?.toLowerCase()?.includes("write-off")) {
      dispositionTemp = {
        ...dispositionTemp,
        assetLocationNameError: "",
        assetLocationAddress1Error: "",
        assetLocationAddress2Error: "",
        assetLocationCityError: "",
        assetLocationStateError: "",
        assetLocationZipError: "",
        assetLocationPhoneError: "",
        assetLotionSalePriceError: "",
        assetLocationContactNameError: "",
        assetLocationContactPhoneError: "",
        assetLocationEmailError: ""
      }
    }
    dispatch(setDispositionData(dispositionTemp))
    for (let key in errors) {
      if (dispositionTemp[errors[key]]) {
        validToShowMyCart = false;
      }
    }
    return validToShowMyCart;
  }

  const validatePaymentAndTitleInfo = () => {    
    const invalidItems: any = []
    dispositionPaymentData?.forEach((item: any)=>{
      if(showPaymentInformation && item?.isChangesOcuured){
        if (!item?.dispositionPayment?.checkOrWireNo ||
          !item?.dispositionPayment?.buyerName ||
          !item?.dispositionPayment?.allocatedAmount ||
          item?.dispositionPayment?.checkOrWireNo?.toString()?.length > 50 ||
          item?.dispositionPayment?.buyerName?.length > 50 ||
          item?.dispositionPayment?.allocatedAmount?.toString()?.length > 30 ||
          item?.dispositionTitle?.trackingNo?.toString()?.length > 100 
        ) {
            invalidItems.push(item)
          }
      }
    })
    return invalidItems
  }

  useEffect(()=>{
    if(fleetAssetCommentsHistory?.length > 0){
      const list = fleetAssetCommentsHistory?.map((item:any)=>{
        return {...item, commentedDate: moment(item.commentedDate).format('MM/DD/YYYY hh:mm a')}
      })
      setCommentHistoryList(list);
    }else{
      setCommentHistoryList([])
    }
  },[fleetAssetCommentsHistory])

  const requestDetailValidationPopup = (isValidatePaymentInfo?: any) => {
    let decriptionTxt = (
      <div>
        <p>Please fill missing request details information.</p>
      </div>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "INFORMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Ok",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        setTabSwitchClicked(false);
        if(isValidatePaymentInfo){
          setValidatePaymentInfo(true)
        }
      },
    });
  }

  useEffect(() => {
    if (fleetAssetComments && fleetAssetComments?.length > 0) {
      dispatch(setFleetCommentsHistory(fleetAssetComments));
      dispatch(setSaveFleetComments([]));
      let isValid = true;
    if (assetOrderHeaderDetail?.orderRequestType === CONSTANTS.DISPOSITION) {
      isValid = validate()
    }
      if (assetOrderHeaderDetail?.orderRequestType === CONSTANTS.DISPOSITION) {
       saveValidComments()
        } else {
          if (!isValid) {
            requestDetailValidationPopup()
          } else {
            return
          }
        }
      } else if(tabSwitchClicked){
          setTabSwitchClicked(false);
          setSelectedKey(tab)
      }
  }, [fleetAssetComments])

    const paymentInformationDispositionChoices = [
      CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY,
      CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY,
      CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_IRON_PLANET,
      CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_IRON_PLANET,
      CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED,
      CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED,
      CONSTANTS.DISPOSITION_CHOICES.JJ_KANE_AUCTION,
      CONSTANTS.DISPOSITION_CHOICES.JJ_KANE_EQUIPMENT_AUCTION,
      CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_WITH_PROCEEDS_LEASED,
      CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_WITH_PROCEEDS_OWNED,
      CONSTANTS.DISPOSITION_CHOICES.PARTY_AUCTION_OWNED,
      CONSTANTS.DISPOSITION_CHOICES.PARTY_AUCTION_LEASED
    ]

    // if need to check whether disposition choice is saved or not, use following condition
    // transferData && transferData[0]?.assetDisposition?.dispositionChoice == assetDisposition?.assetDispositionChoiceId  

  const showPaymentInformation = useMemo(() => {
    if (paymentInformationDispositionChoices?.includes(assetDisposition?.assetDispositionChoice)) {
      return true
    } else {
      return false
    }
  }, [assetDisposition?.assetDispositionChoice, transferData])

  const saveAssetDispositionPaymentAndTitle = () => {
    if(validatePaymentAndTitleInfo()?.length){
      setTabSwitchClicked(false)
      let decriptionTxt = (
        <div>
          <p>Please fill missing request payment details and title information.</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          setTabSwitchClicked(false);
        },
      });
      setValidatePaymentInfo(true)
    } else {
      let payload = dispositionPaymentData?.filter((item: any) => {
        let isRequisitionComplete = savedStatus?.find((saveItem: any) => (saveItem?.fleetItemId == item?.fleetRequestTransDispoReactivationDetailId))
        if(item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && item?.itemStatus !== CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE && isRequisitionComplete?.itemStatus !== CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE && item?.isChangesOcuured){
          return item
        }
      })
      let payloadTemp: any = []
      payload?.map((paymentItem?: any) => {
        let val = {
          fleetRequestTransDispoReactivationDetailId: parseInt(paymentItem?.fleetRequestTransDispoReactivationDetailId),
          dispositionPayment: {
            isCheck: paymentItem?.dispositionPayment?.isCheck,
            checkOrWireNo: paymentItem?.dispositionPayment?.checkOrWireNo,
            buyerName: paymentItem?.dispositionPayment?.buyerName,
            totalCheckOrWireAmount: parseFloat(getOnlyNumbersWithSign(paymentItem?.dispositionPayment?.totalCheckOrWireAmount)),
            allocatedAmount: parseFloat(getOnlyNumbersWithSign(paymentItem?.dispositionPayment?.allocatedAmount))
          },
          dispositionTitle: {
            requestedTitle: paymentItem?.dispositionTitle?.requestedTitle ? moment(paymentItem?.dispositionTitle?.requestedTitle).format("YYYY-MM-DD").toString() : null,
            receivedTitle: paymentItem?.dispositionTitle?.receivedTitle ? moment(paymentItem?.dispositionTitle?.receivedTitle).format("YYYY-MM-DD").toString() : null,
            shippedTitle: paymentItem?.dispositionTitle?.shippedTitle ? moment(paymentItem?.dispositionTitle?.shippedTitle).format("YYYY-MM-DD").toString() : null,
            trackingNo: paymentItem?.dispositionTitle?.trackingNo
          },
          savedBy: userDetails?.emailId
        }
        payloadTemp.push(val)
      })
      if (payloadTemp?.length) {
        dispatch(saveDispositionPayment(payloadTemp))
        setChangesOccuredOnPayment(true)
      } else {
        setChangesOccuredOnPayment(false)
      }
    }
  }

  const saveValidComments = () => {
    if (assetOrderHeaderDetail?.orderRequestType === CONSTANTS.DISPOSITION) {
      let isValid = true;
      isValid = validate()
      if (isValid && !commentsError?.length) {
        let fleetItemId: any = [];
        transferData?.map((request: any, index: any) => {
          request?.fleetAssetDetails?.map((itemLevel: any) => {
            fleetItemId?.push(itemLevel?.fleetRequestDetailId)
          })

        })
        let saveObj: any = {
          fleetRequestTransDispoReactivationDetailIds: fleetItemId,
          physicalAssetLocation: {
            locationName: assetDisposition?.assetLocationName ? assetDisposition?.assetLocationName : "",
            contactName: assetDisposition?.assetLocationContactName ? assetDisposition?.assetLocationContactName : "",
            email: assetDisposition?.assetLocationEmail ? assetDisposition?.assetLocationEmail : "",
            contactPhone: assetDisposition?.assetLocationContactPhone ? assetDisposition?.assetLocationContactPhone : '',
            address: assetDisposition?.assetLocationAddress1 ? assetDisposition?.assetLocationAddress1 : '',
            address1: assetDisposition?.assetLocationAddress1 ? assetDisposition?.assetLocationAddress1 : '',
            address2: assetDisposition?.assetLocationAddress2 ? assetDisposition?.assetLocationAddress2 : '',
            city: assetDisposition?.assetLocationCity ? assetDisposition?.assetLocationCity : '',
            state: assetDisposition?.assetLocationState ? assetDisposition?.assetLocationState : '',
            zip: assetDisposition?.assetLocationZip ? assetDisposition?.assetLocationZip : ''
          },
          assetDisposition: {
            processType: assetDisposition?.assetDispositionProcessType?.label ? assetDisposition?.assetDispositionProcessType?.label : '',
            dispositionChoice: parseInt(assetDisposition?.assetDispositionChoiceId),
            dispositionChoiceText: assetDisposition?.assetDispositionChoice,
            sellToLeased: assetDisposition?.assetDispositionSubChoiceId ? parseInt(assetDisposition?.assetDispositionSubChoiceId) : null,
            sellToLeasedText : assetDisposition?.assetDispositionSubChoice,
            name: assetDisposition?.assetDispositionName ?? '',
            address1: assetDisposition?.assetDispositionAddress1 ?? '',
            address2: assetDisposition?.assetDispositionAddress2 ?? '',
            city: assetDisposition?.assetDispositionCity ?? '',
            state: assetDisposition?.assetDispositionState ?? '',
            zipCode: assetDisposition?.assetDispositionZip ?? '',
            phone: assetDisposition?.assetDispositionPhone ?? '',
            reasonCode: parseInt(assetDisposition?.assetDispositionReasonCodeId) ?? 0,
            replacementFleetAssetOrder: assetDisposition?.replacementFleetAssetOrder ?? '',
            replacementFleetAsset: assetDisposition?.replacementFleetAsset ?? '',
            salePrice: parseInt(getOnlyNumbers(assetDisposition?.assetDispositionSalePrice)) ?? 0,
            totalPrice: parseInt(getOnlyNumbers(assetDisposition?.assetDispositionTotalPrice)) ?? 0,
          },
          isSameAsBranch: assetDisposition?.sameAsBranch,
          savedBy: userDetails?.emailId
        }

        dispatch(setSaveFleetDispositionLocation({}))
        dispatch(getSaveFleetDispositionLocation(saveObj))
      }
    }
  }

  const OnSaveComments = () => {
    let isValid = true;
    if (assetOrderHeaderDetail?.orderRequestType === CONSTANTS.DISPOSITION) {
      isValid = validate()
    }
    if (isValid && !commentsError?.length && comments?.length) {
      setIsChnagedOccuredFlag(false)
      let fleetItemId: any = [];
      transferData?.map((request: any, index: any) => {
        request?.fleetAssetDetails?.map((itemLevel: any) => {
          fleetItemId?.push(itemLevel?.fleetRequestDetailId)
        })

      })
      setComments('');
      dispatch(getSaveFleetComments({
        orderRequestId: parseInt(assetOrderHeaderDetail?.orderRequestId),
        savedBy: userDetails?.emailId,
        comment: comments
      })) 
    } else if(isValid && !commentsError?.length){
      saveValidComments()
    } else {
      if (!isValid) {
        requestDetailValidationPopup()
      } else {
        return
      }
    }
  }

      const onChangeComments = (e?: any, item?: any) => {
        setIsChnagedOccuredFlag(true)
        if(item?.length > 300){
          setCommentsError("Please enter Fleet Request User Comments less than 300 characters.")
        }else{
         setComments(item)
         setCommentsError("")
        }
      }

  const isReceivingBranchDisable = (item?: any) => {
    let isCompleted: any = [];
    item?.fleetAssetDetails?.map((branchItem?: any, branchIndex?: any) => {
      branchItem?.fleetRequestTransDispoReactTaskListTrackings?.map((taskItem?: any, taskIndex?: any) => {
        let savedTask = savedStatus?.filter((taskItem?: any) => taskItem?.fleetItemId == branchItem?.fleetRequestDetailId)?.[0]
        savedTask?.taskList?.map((listItem?: any) => {
          if (listItem?.taskStatus == CONSTANTS.ORDER_STATUS.COMPLETED || listItem?.taskStatus == CONSTANTS.ORDER_STATUS.NBYA) {
            isCompleted.push(listItem);
          }
        })
        if (branchItem?.itemStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED || taskItem?.taskStatus == CONSTANTS.ORDER_STATUS.COMPLETED || taskItem?.taskStatus == CONSTANTS.ORDER_STATUS.NBYA) {
          isCompleted.push(taskItem);
        }
      })

    })
    if (isCompleted?.length) {
      return true
    } else {
      return false
    }
  }

  const iscommentFieldDisable = () => {
    let isCompleted: any = [];
    if(assetOrderHeaderDetail?.orderStatus == CONSTANTS.ORDER_STATUS.COMPLETED || assetOrderHeaderDetail?.orderStatus == CONSTANTS?.ORDER_STATUS.CANCELLED){
        isCompleted.push(assetOrderHeaderDetail)
    }
    if (isCompleted?.length) {
        return true
    } else {
        return false
    }
}

  const iconReturn = (status: any) => {
    return <img src={GetStatusIcon(status).icon} alt="statusIcon" className="statusIcon" />;
  };

  const getItemStatus = useCallback((status: any, fleetItemId?: any) => {
    let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == fleetItemId)
    if (val?.length) {
      return iconReturn(val[0]?.itemStatus)
    } else {
      return iconReturn(status)
    }
  }, [transferData, savedStatus])

  const getItemStatusValue = useCallback((value: any, fleetItemId?: any) => {
    let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == fleetItemId)
    if (val?.length) {
      return formatLableValue(val[0]?.itemStatus)
    } else { return formatLableValue(value) }
  }, [transferData, savedStatus])

  const getFleetItemStatus = useCallback((status: any, fleetItemId?: any) => {
    let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == fleetItemId)
    if (val?.length) {
      return iconReturn(val[0]?.fleetStatus)
    } else {
      return iconReturn(status)
    }
  }, [transferData, savedStatus])

  const getFleetItemStatusValue = useCallback((value: any, fleetItemId?: any) => {
    let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == fleetItemId)
    if (val?.length) {
      return formatLableValue(val[0]?.fleetStatus)
    } else { return formatLableValue(value) }
  }, [transferData, savedStatus])

  const isShowComplete = useCallback((value: any, fleetItemId?: any) => {
    let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == fleetItemId)
    if (val?.length) {
      if (val[0]?.fleetStatus == CONSTANTS?.ORDER_STATUS?.TRANSFER_COMPLETE || val[0]?.fleetStatus == CONSTANTS?.ORDER_STATUS?.REACTIVATION_COMPLETE || val[0]?.fleetStatus == CONSTANTS?.ITEM_STATUS?.DISPOSITION_COMPLETE) {
        return true
      } else {
        return false
      }
    } else if (value == CONSTANTS?.ORDER_STATUS?.TRANSFER_COMPLETE || value == CONSTANTS?.ORDER_STATUS?.REACTIVATION_COMPLETE || value == CONSTANTS?.ITEM_STATUS.DISPOSITION_COMPLETE) {
      return true
    }
    else { return false }
  },[transferData, savedStatus])

  const isShowCancelled = useCallback((value: any, fleetItemId?: any) => {
    let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == fleetItemId)
    if (val?.length) {
      if (val[0]?.fleetStatus == CONSTANTS?.ITEM_STATUS?.CANCELLED) {
        return true
      } else {
        return false
      }
    } else if (value == CONSTANTS?.ITEM_STATUS.CANCELLED) {
      return true
    }
    else { return false }
  }, [transferData, savedStatus])

  useEffect(()=>{
    if(fleetDispositionLocationValue && tabSwitchClicked && (dispositionPaymentDataSaveStatus || !showPaymentInformation || !changesOccuredOnPayment)){
      setTabSwitchClicked(false);
      setSelectedKey(tab)
      setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    }
  }, [fleetDispositionLocationValue, dispositionPaymentDataSaveStatus])

  useEffect(() => {
    if (dispositionPaymentDataSaveStatus && dispositionPaymentDataSaveStatus != null) {
      let transferDataTemp = transferData ? JSON.parse(JSON.stringify(transferData)) : []
      dispositionPaymentData?.map((payItem?: any) => {
          transferDataTemp?.map((transferItem?: any) => {
            transferItem?.fleetAssetDetails?.map((transFleetItem?: any) => {
              if (payItem?.fleetRequestTransDispoReactivationDetailId == transFleetItem?.fleetRequestDetailId) {
                transFleetItem.dispositionPayment = {
                  isCheck: (payItem?.dispositionPayment?.isChanged == true || payItem?.dispositionPayment?.isChanged == undefined) ? payItem?.dispositionPayment?.isCheck : !payItem?.dispositionPayment?.isCheck ,
                  isChanged: false,
                  checkOrWireNo: payItem?.dispositionPayment?.checkOrWireNo || '',
                  buyerName: payItem?.dispositionPayment?.buyerName || '',
                  totalCheckOrWireAmount: payItem?.dispositionPayment?.totalCheckOrWireAmount || '',
                  allocatedAmount:payItem?.dispositionPayment?.allocatedAmount || '',
                }
                transFleetItem.dispositionTitle = payItem?.dispositionTitle
              }
            })
          })
        })
      dispatch(setTransferData(transferDataTemp))
    }
    dispatch(setDispositionPaymentSaveStatus(null))
  }, [dispositionPaymentDataSaveStatus])

  useEffect(() => {
    if (fleetDispositionLocationValue?.hasOwnProperty('orderRequestId')) {
      setIsChnagedOccuredFlag(false)
      let adminTaskGridValuesTemp: any = []
      let transferDataTemp = transferData ? JSON.parse(JSON.stringify(transferData)) : []
      fleetDispositionLocationValue?.fleetRequestDetail?.map((item?: any) => {
        item?.fleetAssetDetails?.map((assetItem?: any) => {
          transferDataTemp?.map((transferItem?: any) => {
            transferItem.physicalAssetLocation = fleetDispositionLocationValue?.physicalAssetLocation
            transferItem.assetDisposition = item?.assetDisposition
            transferItem?.fleetAssetDetails?.map((transFleetItem?: any) => {
              if (assetItem?.fleetRequestDetailId == transFleetItem?.fleetRequestDetailId) {
                dispatch(getFleetAssetChangeLog(parseInt(assetItem?.fleetRequestDetailId)));
                transFleetItem.fleetRequestTransDispoReactTaskListTrackings = assetItem?.fleetRequestTransDispoReactTaskListTrackings
                transFleetItem.itemStatus = assetItem?.itemStatus
                transFleetItem.fleetStatus = assetItem?.fleetStatus
                transFleetItem.orderStatus = assetItem?.orderStatus
                transFleetItem.isOverridePenaltyFee = assetItem?.isOverridePenaltyFee
                transFleetItem.dispositionPenaltyFee = assetItem?.dispositionPenaltyFee

                let listTemp: any = {}
                listTemp.itemId = transFleetItem?.assetNo
                listTemp.taskList = assetItem?.fleetRequestTransDispoReactTaskListTrackings
                listTemp.itemStatus = assetItem?.itemStatus
                listTemp.fleetStatus = assetItem?.fleetStatus
                adminTaskGridValuesTemp?.push(listTemp)

                let savedStatusTemp = savedStatus?.filter((statusItem?: any) => statusItem?.fleetItemId != assetItem?.fleetRequestDetailId)
                let saveObj: any = {}
                saveObj.fleetItemId = assetItem?.fleetRequestDetailId
                saveObj.itemStatus = assetItem?.itemStatus
                saveObj.fleetStatus = assetItem?.fleetStatus
                saveObj.orderStatus = assetItem?.orderStatus
                saveObj.taskList = assetItem?.fleetRequestTransDispoReactTaskListTrackings
                savedStatusTemp?.push(saveObj)
                dispatch(setSavedStatus(savedStatusTemp))
              }
            })
          })
        })
      })
      dispatch(setAdminTaskGridValues(adminTaskGridValuesTemp))
      dispatch(setInitialTaskDetail(adminTaskGridValuesTemp))
      dispatch(setTransferData(transferDataTemp))
      dispatch(setSavedStatus([]))
    }
  }, [fleetDispositionLocationValue])

  const saveChangesOnClick = () => {
    if (showPaymentInformation && assetOrderHeaderDetail?.orderRequestType === CONSTANTS.DISPOSITION) {
      let isValid = validate()
      if (isValid && !commentsError?.length && validatePaymentAndTitleInfo()?.length === 0) {
        OnSaveComments()
        saveAssetDispositionPaymentAndTitle()
        dispatch(setDispositionPaymentSaveStatus(false))
      } else {
        requestDetailValidationPopup(true)
      }
    } else {
      OnSaveComments()
    }
  }

  useEffect(()=>{
    if(tabSwitchClicked && isChangeOccuredFlag){
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "UNSAVED CHANGES",
        isDialogVisible: true,
        subtextcontent: 'You have unsaved changes:   You can leave to discard your changes, or close to continue editing.',
        primaryBtnText: "Save",
        outlineBtnText: "Cancel",
        isSingleConfirmationBtn: false,
        popupOutlinebtnOnclick:  () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          setTabSwitchClicked(false);
          setSelectedKey(tab)
        },
        popupPrimarybtnOnclick: ()=>{
          saveChangesOnClick()
        }
      });
    } else if(tabSwitchClicked) {
      setSelectedKey(tab)
    }
  }, [tabSwitchClicked])
 

  const commentHistoryColumn = [
    {
      key: "commentedDate",
      title: "Date",
      width: 120,
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.commentedDate
              ? moment(row.rowData.commentedDate).format("MM/DD/YYYY HH:mm:ss A")
              : ""}
          </p>
        );
      },
    },
    {
      key: "commentedBy",
      title: "User",
      width: 100
    },
    {
      key: "comment",
      title: "Comment",
      width: 160,
    }
  ];
  
  const onChangeAccordian = (selectedItems: any) => {
    const filterArray = selectedItems.map((i:any) => {
        return parseInt(i.split('_')[2])
    });
    dispatch(setAssetOpenAccordionList(filterArray)) 
    if (selectedItems?.length) {
      const value = selectedItems[selectedItems?.length - 1];
      const result = value.split('_')[2];
      if(assetOrderHeaderDetail?.orderRequestType === CONSTANTS.AFEREQUEST){
        dispatch(getAfeFleetItemDetails(parseInt(result)))
        dispatch(getFleetAfeChangeLog(parseInt(result)));
      }else{
        dispatch(getAssetFleetItemDetails(parseInt(result)))
        dispatch(getFleetAssetChangeLog(parseInt(result)));
      }
    }
  }

  const handleorderLevelReturn = (e?: any, request?: any) => {
    e.preventDefault();
    e.stopPropagation();
    let decriptionTxt = (
      <>
        <p>Please provide a comment before returning order request to the requestor</p>
      </>
    );
    setReturnPopupcontent({
      ...returnPopupcontent,
      titleImg: CommentBee,
      title: "RETURN ENTIRE ORDER TO REQUESTOR",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Return",
      outlineBtnText: "Cancel",
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        setReturnPopupcontent({ ...returnPopupcontent, isDialogVisible: false })
      },
      popupPrimarybtnOnclick: (item: any,
        comment: string,
        actionby: string,
        value: any) => {
          let consolidatedItemId: any = []
          let fleetItemId:any = 0
            const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(request?.fleetAssetDetails));
            saveConsolidatedPoDataArr?.map((item: any) => {
              if (item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && item?.itemStatus !== CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE) {
                if(fleetItemId == 0){
                  fleetItemId = item?.fleetRequestDetailId
                }else{
                  consolidatedItemId.push(item?.fleetRequestDetailId)
                }
              }
            })

        let val = {
          orderId : request?.fleetAssetDetails[0]?.orderRequestId,
          fleetDetailId: parseInt(fleetItemId),
          savedBy: userDetails?.emailId,
          comments: comment,
          consolidatedFleetIds : consolidatedItemId,
          isBOS: assetOrderHeaderDetail?.bosAttachment?.attachmentUrl?.length ? true : false
        }
        dispatch(getAssetFleetItemReturnToRequestor(val));
        setReturnPopupcontent({ ...returnPopupcontent, isDialogVisible: false })
      }
    });
  }

  const getShowOrderReturn = useCallback((request?: any) => {
    let count = 0;
    let isAllValidItem = request?.fleetAssetDetails?.filter((item?: any) => !item?.alreadyReturnedFromFleet)?.length
    if (isAllValidItem == assetOrderHeaderDetail?.quantity && isAuthorized(FLEET_PROCESSING_PERMISSIONS.RETURN_TO_REQUESTOR) && (assetOrderHeaderDetail?.orderRequestType === CONSTANTS.DISPOSITION || assetOrderHeaderDetail?.orderRequestType === CONSTANTS.REACTIVATION)) {
      request?.fleetAssetDetails?.map((item?: any) => {
        if (item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && item?.itemStatus !== CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE && item?.itemStatus !== CONSTANTS.ITEM_STATUS.REACTIVATION_COMPLETE) {
          count++
        }
      })
    }
    if (count > 1) {
      return true
    } else {
      return false
    }
  },[assetFleetItemReturn, assetOrderHeaderDetail])

  const searchCostCenter = (value: any, action: any) => {
    if (action.action === "input-change") {
      dispatch(getCostCenterBySearchString(value))
    }
  };

  const getOrderQty = useCallback(() => {
    return Number(assetOrderHeaderDetail?.quantity || 0).toString()
  }, [assetOrderHeaderDetail, savedStatus])

    const onAssignedToToggleChange = (e?: any) => {
        e.preventDefault();
        if (assignedToForAllValue?.length > 0) {
            const fleetItemIds:any = []
            transferData?.forEach((request: any) => {
              request?.fleetAssetDetails?.map((item: any) => {
                if(item?.itemStatus !== CONSTANTS.ITEM_STATUS.CANCELLED && item?.itemStatus !== CONSTANTS.ITEM_STATUS.TRANSFER_COMPLETE && item?.itemStatus !== CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE && item?.itemStatus !== CONSTANTS.ITEM_STATUS.REACTIVATION_COMPLETE){
                  fleetItemIds?.push(parseInt(item?.fleetRequestDetailId))
                }
              })
            })
            let payload = {
                orderId: parseInt(assetOrderHeaderDetail?.orderRequestId),
                fleetItemIds: e?.target?.checked ? fleetItemIds : [],
                isAssignedToForAll: e?.target?.checked,
                assignedTo: assignedToForAllValue,
                savedBy: userDetails?.emailId
            }
            dispatch(saveAssetAssignedToForAllItem(payload))
            setIsAssignedToChecked(e?.target?.checked)
        } else {
            setIsAssignedToChecked(e?.target?.checked)
        }
    }

const onAssignedToDropdownChange = (e?: any, item?:any) => {
    setAssignedToForAllValue(item?.value)
    const fleetItemIds:any = []
    transferData?.forEach((request: any) => {
      request?.fleetAssetDetails?.map((item: any) => {
        if(item?.itemStatus !== CONSTANTS.ITEM_STATUS.CANCELLED && item?.itemStatus !== CONSTANTS.ITEM_STATUS.TRANSFER_COMPLETE && item?.itemStatus !== CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE && item?.itemStatus !== CONSTANTS.ITEM_STATUS.REACTIVATION_COMPLETE){
          fleetItemIds?.push(parseInt(item?.fleetRequestDetailId))
        }
      })
    })
    let payload = {
        orderId: parseInt(assetOrderHeaderDetail?.orderRequestId),
        fleetItemIds: fleetItemIds,
        isAssignedToForAll: true,
        assignedTo: item?.value,
        savedBy: userDetails?.emailId
    }
    dispatch(saveAssetAssignedToForAllItem(payload))
}
    return <AssetFleetProcessing
                assetOrderHeaderDetail={assetOrderHeaderDetail}
                assignmentTransferTypesList={assignmentTransferTypesList}
                getAssignmentTransferTypeValue={getAssignmentTransferTypeValue}
                onChangeReceivingCostCenter={onChangeReceivingCostCenter}
                setAssignedToError = {setAssignedToError}
                assignedToError = {assignedToError}
                transferData = {transferData}
                setAttachmentChangeFleetId = {setAttachmentChangeFleetId}
                attachmentChangeFleetId = {attachmentChangeFleetId}
                savedStatus = {savedStatus}
                Popupcontent = {Popupcontent}
                hideConfirmationDialog = {hideConfirmationDialog}
                receivingBranchValues = {receivingBranchValues}
                dismissAlert = {dismissAlert}
                setNewAssetError = {setNewAssetError}
                newAssetError = {newAssetError}
                OnSaveComments = {OnSaveComments}
                onChangeComments = {onChangeComments}
                commentsError = {commentsError}
                isReceivingBranchDisable = {isReceivingBranchDisable}
                SavedAdminTaskValue = {SavedAdminTaskValue}
                setAssetDeterminationValue = {setAssetDeterminationValue}
                assetDeterminationValue = {assetDeterminationValue}
                setNewAssetValue = {setNewAssetValue}
                newAssetValue = {newAssetValue}
                comments = {comments}
                getItemStatus = {getItemStatus}
                getItemStatusValue = {getItemStatusValue}
                getFleetItemStatus = {getFleetItemStatus}
                getFleetItemStatusValue = {getFleetItemStatusValue}
                isShowComplete = {isShowComplete}
                setActiveStepperArr = {setActiveStepperArr}
                activeStepperArr = {activeStepperArr}
                isShowAlert={isShowAlert}
                getPreExpandedItem={getPreExpandedItem}
                iscommentFieldDisable = {iscommentFieldDisable}
                activeStepper={activeStepper}
                setActiveStepper={setActiveStepper}
                commentHistoryColumn = {commentHistoryColumn}
                commentHistoryList = {commentHistoryList}
                setIsChnagedOccuredFlag={setIsChnagedOccuredFlag}
                showPaymentInformation={showPaymentInformation}
                validatePaymentInfo={validatePaymentInfo} 
                setValidatePaymentInfo={setValidatePaymentInfo}
                id = {id}
                onChangeAccordian = {onChangeAccordian}
                onChangeCommentsAccordian = {onChangeCommentsAccordian}
                isShowCancelled = {isShowCancelled}
                setCancelComments = {setCancelComments}
                cancelComments = {cancelComments}
                handleorderLevelReturn = {handleorderLevelReturn}
                returnPopupcontent = {returnPopupcontent}
                getShowOrderReturn = {getShowOrderReturn}
                searchCostCenter = {searchCostCenter}
                costCentersBySearchList = {costCentersBySearchList}
                getOrderQty = {getOrderQty}
                onAssignedToToggleChange = {onAssignedToToggleChange}
                isAssignedToChecked={isAssignedToChecked}
                onAssignedToDropdownChange={onAssignedToDropdownChange}
                assignTo={assignTo}
                assignedToForAllValue={assignedToForAllValue}
                afeFleetHeaderDetail={afeFleetHeaderDetail}
              />
}

export default AssetFleetProcessingContainer;